import React from "react";
import { Helmet } from "react-helmet";

export default function Head({
  title,
  url,
  description,
  imageUrl,
}: {
  title: string;
  url: string;
  description: string;
  imageUrl?: string;
}) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta
        name="keywords"
        content="먼데이오프,MondayOFF,Mondayoff,Monday off, mondayoff, monday off,mondayoffblog, mondayoff blog"
      />
      <meta name="description" content={description} />
      <meta property="image" content={imageUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="MondayOFF - Blog" />
      <meta property="og:title" content="MondayOFF - Blog" />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:url" content={url} />
      <meta property="twitter:card" content="summary" />
      <meta property="twitter:title" content="MondayOFF - Blog" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:image" content={imageUrl} />
      <meta property="twitter:description" content={description} />
    </Helmet>
  );
}
